<template>
    <div class="theme-3">
      <div
        @click="emitScrollToElement('page_1')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto ">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page relative d-flex fd-col theme-3-page-1"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <div class="d-flex h-1 w-full">
                <h1
                  :style="{
                    color: selectedHeadingsColor,
                  }"
                  class="w-60 HeaderContent mt-10"
                >
                  {{ organization.name }}
                </h1>
                <h4
                  :style="{
                    color: selectedHeadingsColor,
                  }"
                  class="w-40 HeaderContent mt-3"
                >
                  CASE FOR SUPPORT
                </h4>
              </div>
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative"
              >
                <img
                  class="page-1-img"
                  :src="getImg(0) ? getImg(0).image : logos[0]"
                  @click="openFileInput('fileInput1')"
                  alt=""
                />
                <p
                  class="absolute top-12 right-0 text-2xl cursor-pointer"
                  @click="deleteImage(1)"
                  v-if="showDeleteIcon"
                >
                  <span class="text-red-600 font-extrabold"> X </span>
                </p>
                <input
                  id="fileInput1"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/*"
                  @change="(event) => updateLogo(1, event)"
                />
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <div
        @click="emitScrollToElement('page_2')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page table-of-content"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <h2
                class="HeaderContent"
                :style="{
                  color: selectedHeadingsColor,
                }"
              >
                Table of content
              </h2>
              <table class="w-1">
                <thead>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Letter From the Executive Director
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      3
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Our Story
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      4
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Our Vision
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      5
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Our Mission
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      5
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Current Programs
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      6
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Call For More
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      {{
                        caseStatement?.case_statement_summary?.split(" ")?.length >
                        270
                          ? 8
                          : 7
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Funding Priorities
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      {{
                        caseStatement?.case_statement_summary?.split(" ")?.length >
                        270
                          ? 10
                          : 9
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Success Stories
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      {{
                        caseStatement?.case_statement_summary?.split(" ")?.length >
                        270
                          ? Math.floor(caseStatement.projects?.length / 2) + 1 + 11
                          : Math.floor(caseStatement.projects?.length / 2) + 1 + 10
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Join Us
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      {{
                        caseStatement?.case_statement_summary?.split(" ")?.length >
                        270
                          ? Math.floor(caseStatement.projects?.length / 2) +
                            Math.floor(caseStatement.success_stories?.length / 2) +
                            12
                          : Math.floor(caseStatement.projects?.length / 2) +
                            Math.floor(caseStatement.success_stories?.length / 2) +
                            +11
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Ways to Give
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      {{
                        caseStatement?.case_statement_summary?.split(" ")?.length >
                        270
                          ? Math.floor(caseStatement.projects?.length / 2) +
                            Math.floor(caseStatement.success_stories?.length / 2) +
                            12
                          : Math.floor(caseStatement.projects?.length / 2) +
                            Math.floor(caseStatement.success_stories?.length / 2) +
                            +11
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      Contact
                    </td>
                    <td
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      {{
                        caseStatement?.case_statement_summary?.split(" ")?.length >
                        270
                          ? Math.floor(caseStatement.projects?.length / 2) +
                            Math.floor(caseStatement.success_stories?.length / 2) +
                            12
                          : Math.floor(caseStatement.projects?.length / 2) +
                            Math.floor(caseStatement.success_stories?.length / 2) +
                            +11
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                2
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <div
        @click="emitScrollToElement('page_3')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page letter-page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <img :src="getImg(1) ? getImg(1).image : logos[1]" />
  
              <div class="">
                <div class="my-1">
                  <h2
                    class="HeaderContent m-0"
                    :style="{
                      color: selectedHeadingsColor,
                    }"
                  >
                    Letter From the Executive Director
                  </h2>
                </div>
                <div class="w-100">
                  <pre
                    class="pre-text text-small BodyContent"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                    v-html="
                      caseStatement?.director_letter
                        ?.replace(/\n/g, '<br>')
                        .split(/\s+/)
                        .join(' ')
                    "
                  ></pre>
                </div>
              </div>
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                3
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <div
        @click="emitScrollToElement('page_4')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <div>
                <div>
                  <h2
                    class="HeaderContent mb-0"
                    :style="{
                      color: selectedHeadingsColor,
                    }"
                  >
                    Our Story
                  </h2>
                  <p
                    class="BodyContent mt-0 text-small"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                    v-html="
                      caseStatement?.our_story
                        ?.replace(/\n/g, '<br>')
                        .split(/\s+/)
                        .join(' ')
                    "
                  ></p>
                </div>
                <div>
                  <div class="page-bottom-image d-flex flex-wrap">
                    <div class="h-4">
                      <img
                        :src="getImg(2) ? getImg(2).image : logos[2]"
                        class="w-1 h-1"
                        alt=""
                      />
                    </div>
                    <div class="h-4">
                      <img
                        :src="getImg(3) ? getImg(3).image : logos[3]"
                        class="w-1 h-1"
                        alt=""
                      />
                    </div>
  
                    <div class="h-4">
                      <img
                        :src="getImg(4) ? getImg(4).image : logos[4]"
                        class="w-1 h-1"
                        alt=""
                      />
                    </div>
  
                    <div class="h-4">
                      <img
                        :src="getImg(5) ? getImg(5).image : logos[5]"
                        class="w-1 h-1"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="page-num-mi"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                4
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <div
        @click="emitScrollToElement('page_5')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page our-mission-page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <div class="h-1 w-1 d-flex flex-wrap">
                <div class="w-2 h-2">
                  <img :src="getImg(6) ? getImg(6).image : logos[6]" alt="" />
                </div>
                <div class="w-2 h-2 d-flex align-center j-center">
                  <div class="p-3">
                    <h2
                      class="HeaderContent"
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      Our Vision
                    </h2>
                    <span
                      class="BodyContent text-small"
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                      v-html="
                        caseStatement.vision
                          ?.replace(/\n/g, '<br>')
                          .split(/\s+/)
                          .join(' ')
                      "
                    >
                    </span>
                  </div>
                </div>
                <div class="w-2 h-2 d-flex align-center j-center">
                  <div class="p-3">
                    <h2
                      class="HeaderContent"
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      Our Mission
                    </h2>
                    <span
                      class="BodyContent text-small"
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                      v-html="
                        caseStatement.mission
                          ?.replace(/\n/g, '<br>')
                          .split(/\s+/)
                          .join(' ')
                      "
                    >
                    </span>
                  </div>
                </div>
                <div class="w-2 h-2">
                  <img :src="getImg(7) ? getImg(7).image : logos[7]" />
                </div>
              </div>
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                5
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <div
        @click="emitScrollToElement('page_6')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <div>
                <div>
                  <h2
                    class="HeaderContent"
                    :style="{
                      color: selectedHeadingsColor,
                    }"
                  >
                    Current Programs
                  </h2>
                  <pre
                    class="pre-text text-small"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                    v-if="caseStatement?.case_statement_summary"
                    v-html="
                      getTheText(caseStatement.case_statement_summary, 0, 270)
                    "
                  ></pre>
                </div>
                <div>
                  <div class="page-bottom-image d-flex flex-wrap">
                    <div class="h-4">
                      <img
                        class="h-1"
                        :src="getImg(8) ? getImg(8).image : logos[8]"
                        alt=""
                      />
                    </div>
                    <div class="h-4">
                      <img
                        class="h-1"
                        :src="getImg(9) ? getImg(9).image : logos[9]"
                        alt=""
                      />
                    </div>
                    <div class="h-4">
                      <img
                        class="h-1"
                        :src="getImg(10) ? getImg(10).image : logos[10]"
                        alt=""
                      />
                    </div>
                    <div class="h-4">
                      <img
                        class="h-1"
                        :src="getImg(11) ? getImg(11).image : logos[11]"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="page-num-mi"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{ 6 }}
              </div>
            </section>
          </div>
        </div>
      </div>
      <div
        @click="emitScrollToElement('page_7')"
        v-if="caseStatement?.case_statement_summary?.split(' ')?.length > 270"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
              v-if="
                caseStatement?.case_statement_summary?.split(' ')?.length > 270
              "
            >
              <div>
                <div>
                  <pre
                    class="pre-text text-small"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                    v-if="caseStatement?.case_statement_summary"
                    v-html="
                      getTheText(caseStatement.case_statement_summary, 270, 625)
                    "
                  ></pre>
                </div>
                <div>
                  <div class="page-bottom-image d-flex flex-wrap ">
                    <div class="h-4">
                      <img
                        class="h-1"
                        :src="getImg(12) ? getImg(12).image : logos[12]"
                        alt=""
                      />
                    </div>
                    <div class="h-4">
                      <img
                        class="h-1"
                        :src="getImg(13) ? getImg(13).image : logos[13]"
                        alt=""
                      />
                    </div>
                    <div class="h-4">
                      <img
                        class="h-1"
                        :src="getImg(14) ? getImg(14).image : logos[14]"
                        alt=""
                      />
                    </div>
                    <div class="h-4">
                      <img
                        class="h-1"
                        :src="getImg(15) ? getImg(15).image : logos[15]"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="page-num-mi"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{ 7 }}
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <!-- <div
        @click="emitScrollToElement('page_8')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer transform transition-transform duration-100 hover:scale-105 my-3"
        v-if="caseStatement?.case_statement_summary?.split(' ')?.length > 310"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
              v-if="
                caseStatement?.case_statement_summary?.split(' ')?.length > 310
              "
            >
              <div class="d-flex flex-wrap h-1">
                <div class="w-100">
                  <pre
                    class="pre-text text-small"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                    v-html="
                      caseStatement.case_statement_summary
                        ?.replace(/\n/g, '<br>')
                        .split(/\s+/)
                        .slice(310)
                        .join(' ')
                    "
                  ></pre>
                </div>
              </div>
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{ 8 }}
              </div>
            </section>
          </div>
        </div>
      </div> -->
  
      <div
        @click="emitScrollToElement('page_9')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page letter-page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <div class="relative">
                <img :src="getImg(16) ? getImg(16).image : logos[16]" alt="" />
              </div>
              <h2
                class="HeaderContent mb-0"
                :style="{
                  color: selectedHeadingsColor,
                }"
              >
                Call for More
              </h2>
              <div class="w-full">
                <p
                  class="BodyContent text-small"
                  :style="{
                    color: selectedBodyTextColor,
                  }"
                  v-html="
                    caseStatement?.call_for_more
                      ?.replace(/\n/g, '<br>')
                      .split(/\s+/)
                      .join(' ')
                  "
                ></p>
              </div>
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 270
                    ? 8
                    : 7
                }}
              </div>
            </section>
          </div>
        </div>
      </div>
      <div
        @click="emitScrollToElement('page_10')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page letter-page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <h3
                class="HeaderContent mb-0"
                :style="{
                  color: selectedHeadingsColor,
                }"
              >
                {{ organization.name }} has a 3-year fundraising goal of ${{
                  (organization.total_fundraising_goal_3y - 0).toLocaleString()
                }}
                over a 3-year period to support both our Annual Operations and our
                New and Expansion Projects.
              </h3>
              <div class="w-full">
                <h3
                  class="BodyContent text-bold"
                  :style="{
                    color: selectedBodyTextColor,
                  }"
                >
                  Below is a breakdown of our goal:
                </h3>
                <table class="w-1 breakdown-table mt-3">
                  <tbody>
                    <tr
                      v-for="(project, index) in caseStatement?.projects"
                      :key="index"
                    >
                      <td
                        :style="{
                          borderColor: selectedHeadingsColor,
                        }"
                      >
                        <p
                          class="BodyContent"
                          :style="{
                            color: selectedBodyTextColor,
                          }"
                        >
                          {{ project.project_name }}
                        </p>
                      </td>
                      <td
                        :style="{
                          borderColor: selectedHeadingsColor,
                        }"
                      >
                        <p
                          :style="{
                            color: selectedBodyTextColor,
                            'font-weight': 'bold',
                          }"
                        >
                          ${{ project.project_cost.toLocaleString() }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 270
                    ? 9
                    : 8
                }}
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <div
        @click="emitScrollToElement('page_11')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <h2
                class="HeaderContent mb-0"
                :style="{
                  color: selectedHeadingsColor,
                }"
              >
                {{ organization?.name }} Funding Priorities
              </h2>
              <div >
                <h2
                  class="HeaderContent mb-0"
                  :style="{
                    color: selectedHeadingsColor,
                  }"
                >
                  {{ caseStatement?.organization_name }} Funding Priorities
                </h2>
                <div v-for="(project, idx) in caseStatement.projects" :key="idx">
                  <div v-if="idx == 0">
                    <h5
                      class="HeaderContent text-bold mb-0"
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      {{ project.project_name }}:
                      {{ formatToDecimal(project.project_cost) }}
                    </h5>
                    <p
                      class="BodyContent text-small"
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      {{
                        project.all_questions_answers?.find(
                          (item) => item.question_name === "new_project_goals_rationale_goals"
                        ).question_answer
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <h5>
                  ANNUAL OPERATIONS:
                  {{
                    formatToDecimal(
                      caseStatement?.totals?.annual_fundraising_goal || 0
                    )
                  }}
                </h5>
              </div>
  
              <div class="d-flex pb-3">
                <div class="w-2">
                  <h4
                    class="HeaderContent mb-0 text-center"
                    :style="{
                      color: selectedHeadingsColor,
                    }"
                  >
                    Projected Expenses
                  </h4>
                  <div class="d-flex align-center j-center text-center">
                    <ExpensesChart
                      :selectedBodyTextColor="selectedBodyTextColor"
                      :selectedHeadingsColor="selectedHeadingsColor"
                      :expensesData="caseStatement?.expenses" />
                  </div>
                </div>
  
                <div class="w-2">
                  <h4
                    class="HeaderContent mb-0 text-center"
                    :style="{
                      color: selectedHeadingsColor,
                    }"
                  >
                    Projected Revenues
                  </h4>
                  <div class="d-flex align-center j-center h-1 text-center">
                    <RevenuesChart
                      :selectedBodyTextColor="selectedBodyTextColor"
                      :selectedHeadingsColor="selectedHeadingsColor"
                      :revenuesData="caseStatement?.revenues" />
                  </div>
                </div>
              </div>
  
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 270
                    ? 10
                    : 9
                }}
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <!-- <div
        @click="emitScrollToElement('page_12')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer transform transition-transform duration-100 hover:scale-105 my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page relative h-1 priorities-page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              
              <div class="h-2">
                <img
                  class="page-1-img"
                  :src="getImg(17) ? getImg(17).image : logos[17]"
                  alt=""
                />
              </div>
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 270
                    ? 11
                    : 10
                }}
              </div>
            </section>
          </div>
        </div>
      </div> -->
  
      <div
        @click="emitScrollToElement('page_13')"
        v-if="caseStatement.projects?.length > 1"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page priorities-page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
              v-if="caseStatement.projects?.length > 1"
            >
              <h2
                class="HeaderContent mb-0"
                :style="{
                  color: selectedHeadingsColor,
                }"
              >
                {{ caseStatement?.organization_name }} Funding Priorities
              </h2>
              <div v-for="(project, idx) in caseStatement.projects" :key="idx">
                <div v-if="idx > 0 && idx < 3">
                  <h5
                    class="HeaderContent text-bold mb-0"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                  >
                    {{ project.project_name }}:
                    {{ formatToDecimal(project.project_cost) }}
                  </h5>
                  <p
                    class="BodyContent text-small"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                  >
                    {{
                      project.all_questions_answers?.find(
                        (item) => item.question_name === "new_project_goals_rationale_goals"
                      ).question_answer
                    }}
                  </p>
                </div>
              </div>
  
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 270
                    ? 12
                    : 11
                }}
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <div
        @click="emitScrollToElement('page_14')"
        v-if="caseStatement.projects?.length > 3"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page priorities-page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
              v-if="caseStatement.projects?.length > 3"
            >
              <h2
                class="HeaderContent mb-0"
                :style="{
                  color: selectedHeadingsColor,
                }"
              >
                {{ caseStatement?.organization_name }} Funding Priorities
              </h2>
              <div v-for="(project, idx) in caseStatement.projects" :key="idx">
                <div v-if="idx > 2 && idx < 5">
                  <h5
                    class="HeaderContent text-bold mb-0"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                  >
                    {{ project.project_name }}:
                    {{ formatToDecimal(project.project_cost) }}
                  </h5>
                  <p
                    class="BodyContent text-small"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                  >
                    {{
                      project.all_questions_answers?.find(
                        (item) => item.question_name === "new_project_goals_rationale_goals"
                      ).question_answer
                    }}
                  </p>
                </div>
              </div>
  
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 270
                    ? 13
                    : 12
                }}
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <div
        @click="emitScrollToElement('page_15')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section class="p-0">
              <div
                class="page h-1 w-1 d-flex flex-wrap"
                :style="{
                  backgroundColor: selectedBackgroundColor,
                }"
              >
                <div class="w-2 h-2 d-flex align-center j-center">
                  <div class="">
                    <h1
                      class="HeaderContent"
                      :style="{
                        color: selectedHeadingsColor,
                      }"
                    >
                      Success Stories
                    </h1>
                  </div>
                </div>
                <div class="w-2 h-2">
                  <div class="relative h-1 success-stories-img">
                    <img
                      :src="getImg(18) ? getImg(18).image : logos[18]"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  class="w-full h-2"
                  v-for="(story, idx) in caseStatement.success_stories"
                  :key="story.id"
                >
                  <div v-if="idx == 0">
                    <p
                      class="BodyContent"
                      :style="{
                        color: selectedBodyTextColor,
                      }"
                    >
                      {{ story?.user_story }}
                    </p>
                  </div>
                </div>
                <div
                  class="page-num"
                  :style="{
                    borderColor: selectedHeadingsColor,
                    color: selectedHeadingsColor,
                  }"
                >
                  {{
                    caseStatement?.case_statement_summary?.split(" ")?.length >
                    270
                      ? Math.floor(caseStatement.projects?.length / 2) + 1 + 11
                      : Math.floor(caseStatement.projects?.length / 2) + 1 + 10
                  }}
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <div
        @click="emitScrollToElement('page_16')"
        v-if="caseStatement.success_stories?.length > 1"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="p-0 e"
              v-if="caseStatement.success_stories?.length > 1"
            >
              <div
                class="page h-1 w-1 d-flex flex-wrap"
                :style="{
                  backgroundColor: selectedBackgroundColor,
                }"
              >
                <div
                  v-for="(story, idx) in caseStatement.success_stories"
                  :key="story.id"
                >
                  <div v-if="idx > 0" class="w-full h-2">
                    <div>
                      <p
                        class="BodyContent"
                        :style="{
                          color: selectedBodyTextColor,
                        }"
                      >
                        {{ story?.user_story }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="page-num"
                  :style="{
                    borderColor: selectedHeadingsColor,
                    color: selectedHeadingsColor,
                  }"
                >
                  {{
                    caseStatement?.case_statement_summary?.split(" ")?.length >
                    270
                      ? Math.floor(caseStatement.projects?.length / 2) + 1 + 12
                      : Math.floor(caseStatement.projects?.length / 2) + 1 + 11
                  }}
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
  
      <!-- <div
        @click="emitScrollToElement('page_17')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer transform transition-transform duration-100 hover:scale-105 my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <h2
                class="HeaderContent"
                :style="{
                  color: selectedHeadingsColor,
                }"
              >
                Donor Recognition and Benefits
              </h2>
              <table
                class="w-1 donor-table mt-3"
                @click="redirectTo('stewardship-preparation')"
              >
                <thead
                  :style="{
                    borderColor: selectedHeadingsColor,
                    backgroundColor: selectedBackgroundColor,
                  }"
                >
                  <tr>
                    <th
                      class="text-small"
                      :style="{
                        color: selectedBodyTextColor,
                        borderColor: selectedHeadingsColor,
                      }"
                    >
                      DONOR BENEFIT
                    </th>
                    <th
                      v-for="(row, id) in tableStateStore"
                      :key="id"
                      class="text-small"
                      :style="{
                        color: selectedBodyTextColor,
                        borderColor: selectedHeadingsColor,
                      }"
                    >
                      <div class="flex">
                        <span v-if="row.giftAmount != 'Various (<$25k)'">
                          $
                        </span>
                        <span>
                          {{ row.giftAmount.toLocaleString() }}
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mainRow, index) in tableState.rows" :key="index">
                    <td
                      :style="{
                        borderColor: selectedHeadingsColor,
                      }"
                    >
                      <p
                        class="BodyContent text-small"
                        :style="{
                          color: selectedBodyTextColor,
                        }"
                      >
                        {{ mainRow.benefit_name }}
                      </p>
                    </td>
                    <td
                      v-for="(row, idx) in tableStateStore"
                      :key="idx"
                      :style="{
                        borderColor: selectedHeadingsColor,
                      }"
                    >
                      <div
                        :class="{ checked: mainRow.prospect[row.giftAmount] }"
                        :style="{
                          backgroundColor: selectedBodyTextColor,
                        }"
                      ></div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                class="page-num"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 270
                    ? Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      13
                    : Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      +12
                }}
              </div>
            </section>
          </div>
        </div>
      </div> -->
  
      <div
        @click="emitScrollToElement('page_18')"
        class="w-[270px] aspect-page-landscape side-page-container overflow-hidden relative bg-white rounded-md shadow-md cursor-pointer my-3"
      >
        <div class="mini-page-landscape mx-auto min-w-[297mm]">
          <div
            class="theme-page-mini flex justify-center min-w-[297mm] min-h-[210mm] aspect-page-landscape"
          >
            <section
              class="page"
              :style="{
                backgroundColor: selectedBackgroundColor,
              }"
            >
              <div>
                <div>
                  <h2
                    class="HeaderContent m-0"
                    :style="{
                      color: selectedHeadingsColor,
                    }"
                  >
                    Join Us
                  </h2>
                  <p
                    class="BodyContent"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                  >
                    {{ caseStatement?.case_statement_join_us_message }}
                  </p>
  
                  <h2
                    class="HeaderContent m-0"
                    :style="{
                      color: selectedHeadingsColor,
                    }"
                  >
                    Ways To Give:
                  </h2>
                  <div class="list-ways d-flex flex-wrap pt-1 pb-1">
                    <div
                      class="box w-2 pr-1 mb-2 d-flex align-center"
                      v-for="(
                        item, idx
                      ) in caseStatement.case_statement_ways_to_give"
                      :key="idx"
                    >
                      <font-awesome-icon
                        v-if="item.icon"
                        :icon="item.icon"
                        class="ways-icon"
                        :style="{
                          color: selectedHeadingsColor,
                        }"
                      />
                      <span> </span>
                      <p
                        class="BodyContent text p-px m-0"
                        :style="{
                          color: selectedBodyTextColor,
                        }"
                      >
                        {{ item.label }}
                      </p>
                    </div>
                  </div>
  
                  <h2
                    class="HeaderContent m-0"
                    :style="{
                      color: selectedHeadingsColor,
                    }"
                  >
                    Contact Us:
                  </h2>
                  <p
                    class="BodyContent"
                    :style="{
                      color: selectedBodyTextColor,
                    }"
                  >
                    {{ organization.name }}
                    <br />
                    {{ organization.director_name }}
                    <br />
                    {{ organization.address }}
                    <br />
                    {{ organization.phone }}
  
                    <br />
                    {{ organization.website }}
                  </p>
                </div>
                <div>
                  <div class="page-bottom-image d-flex flex-wrap">
                    <div class="h-4 w-1">
                      <img
                        class="h-1 w-1"
                        :src="getImg(19) ? getImg(19).image : logos[19]"
                        alt=""
                      />
                    </div>
  
                    <div class="h-4 w-1">
                      <img
                        class="h-1 w-1"
                        :src="getImg(20) ? getImg(20).image : logos[20]"
                        alt=""
                      />
                    </div>
                    <div class="h-4 w-1">
                      <img
                        class="h-1 w-1"
                        :src="getImg(21) ? getImg(21).image : logos[21]"
                        alt=""
                      />
                    </div>
                    <div class="h-4 w-1">
                      <img
                        class="h-1 w-1"
                        :src="getImg(22) ? getImg(22).image : logos[22]"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="page-num-mi"
                :style="{
                  borderColor: selectedHeadingsColor,
                  color: selectedHeadingsColor,
                }"
              >
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 270
                    ? Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      12
                    : Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      +11
                }}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  // Vue core imports
  import { ref, onMounted, reactive, computed, watch } from "vue";
  
  // Components
  import ExpensesChart from "@/components/charts/ExpensesChart.vue";
  import RevenuesChart from "@/components/charts/RevenuesChart.vue";
  
  // Composables
  import formatToDecimal from "@/composables/formatToDecimal";
  
  // Stores
  import { useAuthStore } from "@/stores/auth";
  import { useUserProjectsStore } from "@/stores/projects";
  import { useRoutesManagement } from "@/stores/routesManagement";
  
  // Global config
  import global from "@/global";
  
  // Props definition
  const props = defineProps({
    selectedHeadingsColor: String,
    selectedBodyTextColor: String,
    selectedBackgroundColor: String,
  });
  
  // Emits
  const emit = defineEmits(['emitScrollToElement']);
  
  // Store instances
  const authStore = useAuthStore();
  const projectsStore = useUserProjectsStore();
  const routesManagementStore = useRoutesManagement();
  
  // State
  const showDeleteIcon = ref(false);
  const organization = ref({});
  const caseStatement = ref({});
  const targetAllocation = ref([]);
  const tableStateStore = ref([]);
  const waysDataFormat = ref([]);
  
  const tableState = reactive({
    headers: [],
    rows: [],
  });
  
  const giftPyramidTableState = reactive({
    data: [],
  });
  
  const logos = ref([
    "/images/page-1.png",
    "/images/page-2.png",
    "/images/our-story-1.png",
    "/images/our-story-2.png",
    "/images/our-story-3.png",
    "/images/our-story-4.png",
    "/images/our-mission-1.png",
    "/images/our-mission-2.png",
    "/images/current-programs-img-1.png",
    "/images/current-programs-img-2.png",
    "/images/current-programs-img-3.png",
    "/images/current-programs-img-4.png",
    "/images/current-programs-img-1.png",
    "/images/current-programs-img-2.png",
    "/images/current-programs-img-3.png",
    "/images/current-programs-img-4.png",
    "/images/call-for-more-img.png",
    "/images/priorities-page-img.png",
    "/images/success-stories.png",
    "/images/contact-page-img-1.png",
    "/images/contact-page-img-2.png",
    "/images/contact-page-img-3.png",
    "/images/contact-page-img-4.png",
  ]);
  
  // Methods
  function getImg(order) {
    if (!caseStatement?.value?.attachments) return '';
    return caseStatement.value.attachments.find(e => e.order === order) || '';
  }
  
  function getTheText(text, fromIndex, toIndex) {
    if (!text?.length) return '';
    
    text = text.replace(/\n/g, "<br>").split(/\s+/);
    let data = '';
    let lastIndex = '';
    
    if (fromIndex === 0) {
      data = text.slice(fromIndex, toIndex);
      data.forEach((e, i) => {
        if (e.includes("<br>")) lastIndex = i;
      });
      
      if (lastIndex >= toIndex - 20) {
        data = data.slice(fromIndex, lastIndex).join(" ");
      } else {
        data = data.join(" ");
      }
    } else {
      data = text.slice(0, fromIndex);
      data.forEach((e, i) => {
        if (e.includes("<br>")) lastIndex = i;
      });
      
      if (lastIndex >= fromIndex - 20) {
        text[lastIndex] = text[lastIndex].replace(/<br><br>/g, "");
        data = text.slice(lastIndex, toIndex).join(" ");
      } else {
        data = text.slice(fromIndex, toIndex).join(" ");
      }
    }
    
    return data;
  }
  
  function openFileInput(inputId) {
    document.getElementById(inputId)?.click();
  }
  
  function emitScrollToElement(id) {
    emit('emitScrollToElement', id);
  }
  
  // API calls
  async function fetchCaseStatementData() {
    try {
      const res = await fetch(`${global.API_URL}/case-statements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      caseStatement.value = data.data;
      
      // Ensure case_statement_ways_to_give is an array
      if (!Array.isArray(caseStatement.value.case_statement_ways_to_give)) {
        caseStatement.value.case_statement_ways_to_give = [];
      }
      
      // Format ways to give data
      waysDataFormat.value = [];
      caseStatement.value.case_statement_ways_to_give?.forEach((item) => {
        if (item.subOption) {
          item.subOption.forEach((sub) => {
            if (sub.isSelected) {
              waysDataFormat.value.push(sub);
            }
          });
        }
        if (item.isSelected) {
          waysDataFormat.value.push(item);
        }
      });
      caseStatement.value.case_statement_ways_to_give = waysDataFormat.value;
    } catch (err) {
      console.error('Error fetching case statement:', err);
    }
  }
  
  async function fetchOrganizationData() {
    try {
      const res = await fetch(`${global.API_URL}/organizations`, {
        method: "GET", 
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      organization.value = data.data;
    } catch (err) {
      console.error('Error fetching organization:', err);
    }
  }
  
  async function getGiftPyramid() {
    try {
      const res = await fetch(`${global.website_URL}/api/v1/gift-pyramid`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json", 
        },
      });
      const data = await res.json();
      tableStateStore.value = JSON.parse(data.data.levels);
    } catch (err) {
      console.error('Error fetching gift pyramid:', err);
    }
  }
  
  // Gift pyramid calculations
  function setProperTargetAllocation(totalFundraisingGoal) {
    if (totalFundraisingGoal >= 20000000) {
      targetAllocation.value = [0.5, 0.2, 0.15, 0.15, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 17500000) {
      targetAllocation.value = [0.4, 0.15, 0.15, 0.3, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 15000000) {
      targetAllocation.value = [0.15, 0.2, 0.25, 0.4, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 12500000) {
      targetAllocation.value = [0.15, 0.2, 0.2, 0.45, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 10000000) {
      targetAllocation.value = [0.1, 0.15, 0.15, 0.6, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 7500000) {
      targetAllocation.value = [0.0, 0.3, 0.25, 0.2, 0.25, 0.0];
    } else if (totalFundraisingGoal >= 5000000) {
      targetAllocation.value = [0.0, 0.2, 0.27, 0.17, 0.35, 0.0];
    } else if (totalFundraisingGoal >= 2500000) {
      targetAllocation.value = [0.0, 0.0, 0.0, 0.4, 0.375, 0.225];
    } else if (totalFundraisingGoal >= 1000000) {
      targetAllocation.value = [0.0, 0.0, 0.0, 0.45, 0.25, 0.3];
    } else if (totalFundraisingGoal > 500000) {
      targetAllocation.value = [0.0, 0.0, 0.0, 0.1, 0.3, 0.6];
    } else if (totalFundraisingGoal == 500000) {
      targetAllocation.value = [0.0, 0.0, 0.0, 0.5, 0.4, 0.1];
    }
  }
  
  function buildTableData(prospectRatio, totalFundraisingGoal, prospectNamesArr) {
    const giftAmounts = [5000000, 1000000, 500000, 250000, 100000, 25000];
    let totalPercentage = 0;
    let calculatedTotalFundraisingGoal = 0;
    let tempTableData = [];
  
    giftAmounts.forEach((ga, idx) => {
      let TargetAllocationTemp = targetAllocation.value[idx];
      let targetAllocationValue = 0;
      let numberOfGiftsNeeded = 0;
      let amountByGiftLevel = 0;
      let calculatedFundraisingAllocationPercentage = 0;
  
      if (totalPercentage + TargetAllocationTemp * 100 <= 100) {
        targetAllocationValue = totalFundraisingGoal * TargetAllocationTemp;
        numberOfGiftsNeeded = Math.ceil(targetAllocationValue / ga);
        amountByGiftLevel = numberOfGiftsNeeded * ga;
        calculatedFundraisingAllocationPercentage = +((amountByGiftLevel * 100) / totalFundraisingGoal).toFixed(1);
        calculatedTotalFundraisingGoal += amountByGiftLevel;
        totalPercentage += calculatedFundraisingAllocationPercentage;
      } else {
        TargetAllocationTemp = (100 - totalPercentage) / 100;
        targetAllocationValue = totalFundraisingGoal * TargetAllocationTemp;
        numberOfGiftsNeeded = Math.ceil(targetAllocationValue / ga);
        amountByGiftLevel = numberOfGiftsNeeded * ga;
        calculatedFundraisingAllocationPercentage = +((amountByGiftLevel * 100) / totalFundraisingGoal).toFixed(1);
  
        if (amountByGiftLevel + calculatedTotalFundraisingGoal >= totalFundraisingGoal) {
          numberOfGiftsNeeded = Math.ceil(targetAllocationValue / ga) - 1;
          amountByGiftLevel = numberOfGiftsNeeded * ga;
          calculatedFundraisingAllocationPercentage = +((amountByGiftLevel * 100) / totalFundraisingGoal).toFixed(1);
        }
  
        calculatedTotalFundraisingGoal += amountByGiftLevel;
        totalPercentage += calculatedFundraisingAllocationPercentage;
      }
  
      tempTableData.push({
        giftAmount: ga,
        numberOfGiftsNeeded,
        numberOfProspectsNeeded: numberOfGiftsNeeded * prospectRatio,
        amountByGiftLevel,
        cumulativeGiftAmount: tempTableData[idx - 1] 
          ? amountByGiftLevel + tempTableData[idx - 1].cumulativeGiftAmount 
          : amountByGiftLevel,
        fundingAllocation: calculatedFundraisingAllocationPercentage,
        prospectNames: { names: "" },
      });
    });
  
    tempTableData.push({
      giftAmount: "Various",
      numberOfGiftsNeeded: "-",
      numberOfProspectsNeeded: "-", 
      amountByGiftLevel: totalFundraisingGoal - calculatedTotalFundraisingGoal,
      cumulativeGiftAmount: totalFundraisingGoal,
      fundingAllocation: parseFloat((100 - totalPercentage).toFixed(1)),
      prospectNames: { names: "" },
    });
  
    tempTableData.forEach((row, idx) => {
      row.prospectNames = prospectNamesArr[idx];
    });
  
    giftPyramidTableState.data = tempTableData;
  }
  
  function buildTableHeaders(prospectRatio, totalFundraisingGoal, prospectNames) {
    buildTableData(
      prospectRatio,
      roundToNearest100000(totalFundraisingGoal),
      prospectNames
    );
    
    const tempHeaders = giftPyramidTableState.data.map(di => ({
      name: "",
      value: `${di.amountByGiftLevel}`,
      order: di.prospectNames?.order
    }));
    
    tableState.headers = tempHeaders.sort((a, b) => a.order - b.order);
  }
  
  function roundToNearest100000(number) {
    return Math.ceil(number / 100000) * 100000;
  }
  
  // Lifecycle hooks
  onMounted(async () => {
    await Promise.all([
      fetchCaseStatementData(),
      fetchOrganizationData(),
      getGiftPyramid(),
    ]);
  });
  </script>
  
  <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Spectral:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Montserrat+Alternates:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Squada+One&display=swap");
  
  * {
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    box-sizing: border-box;
    outline: 0;
  }
  
  html {
    scroll-behavior: smooth;
  }
  code,
  kbd,
  samp,
  pre {
    font-size: 14px;
  }
  
  .page {
    position: relative;
    margin: 2rem auto;
    width: 1056px;
    height: 594px;
    aspect-ratio: 16 / 9;
    box-shadow: 1px 1px 3px 1px #333;
    background-color: #ffffff;
    border-collapse: separate;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 2rem 3rem;
  }
  .side-page-container {
    max-height: 280px;
    min-height: 280px;
  }
  .fileInput-hidden {
    display: none;
  }
  
  .company-logo {
    width: 200px;
    height: auto;
    object-fit: contain;
    margin-bottom: 2rem;
  }
  
  .page-num {
    position: absolute;
    right: 2rem;
    bottom: 1.5rem;
    font-size: 12px;
  }
  .page-num span {
    margin: 0 0.5rem;
    opacity: 0.5;
  }
  
  .page-num-mi {
    position: absolute;
    right: 2rem;
    bottom: 1.5rem;
    font-size: 12px;
  }
  .page-num-mi span {
    margin: 0 0.5rem;
    opacity: 0.5;
  }
  
  .theme-3 .page-num-mi {
    top: 0;
    right: 0;
    left: auto;
    bottom: auto;
    font-size: 16px;
    color: #8c2204;
    border-bottom: 1px solid #8c2204;
    border-left: 1px solid #8c2204;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .theme-3 .learning-page .page-num-mi {
    border-color: #f2eae0;
    color: #f2eae0;
  }
  
  .our-story-img {
    width: 40%;
    height: 260px;
    position: absolute;
    right: 0;
    top: 0;
    object-fit: cover;
  }
  
  .annual-operations-img {
    width: 25%;
    height: 360px;
    position: absolute;
    right: 0;
    top: 0;
    object-fit: cover;
    object-position: bottom;
  }
  
  .annual-programs-img {
    position: relative;
    top: -2rem;
    width: calc(100% + 3rem);
    height: calc(100% + 4rem);
    object-fit: cover;
  }
  
  .director-img {
    position: relative;
    top: -2rem;
    left: -3rem;
    width: calc(100% + 3rem);
    height: calc(100% + 4rem);
    object-fit: cover;
  }
  
  .success-stories-img {
    position: relative;
    top: -2rem;
    object-fit: cover;
    object-position: center;
    padding-inline-start: 5rem;
  }
  
  .txt-over-img {
    position: absolute;
    z-index: 1;
    transform: rotate(90deg);
    width: 100%;
    text-wrap: nowrap;
    top: 5rem;
    right: -1.5rem;
  }
  
  .p-rel {
    position: relative;
  }
  
  .top-pattern {
    position: absolute;
    top: 0;
    right: 0;
    width: 200px;
    height: auto;
  }
  .bottom-pattern {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200px;
    height: auto;
  }
  
  .title {
    position: relative;
    border-left: 5px solid #234b29;
    padding-left: 1rem;
    font-weight: 800;
    margin-top: 1.5rem;
    font-size: 18px;
  }
  .price {
    margin: 0 1rem;
    padding: 0 1rem;
    background-color: #234b29;
    color: #ffffff;
  }
  .text-center {
    text-align: center;
  }
  .text-justify {
    text-align: justify;
  }
  .text-italic {
    font-style: italic;
  }
  .text-small {
    font-size: 14px;
  }
  .text-bold {
    font-weight: bolder;
  }
  
  .page-bottom-image {
      width: 100%;
      position: absolute;
      bottom: 82px;
      transform: translate(-3rem, 5.2rem);
  }
  .page-bottom-image > div {
      width: 25%;
  }
  
  .page-bottom-image img {
    object-fit: cover;
    height: 183px;
    display: block;
  }
  
  
  .contact-sec {
    background: linear-gradient(#234b29 50%, #ffffff 50%);
  }
  
  .contact-sec .main-img {
    width: 100%;
    height: 60%;
    object-fit: cover;
    margin-top: 1rem;
  }
  
  .contact-sec .box {
    padding: 2rem;
  }
  .contact-sec .box .img {
    width: 50px;
    height: 50px;
    background-color: #234b29;
    border-radius: 3px;
    overflow: hidden;
    object-fit: contain;
  }
  .contact-sec .box p {
    font-size: 13px;
  }
  .contact-sec .box .box-title {
    font-size: 15px;
    font-weight: 700;
    color: #000000;
  }
  
  .contact-sec .box .img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .box-icon {
    padding: 0.5rem;
    width: 200px;
    box-shadow: 0px 0px 5px 5px #0000000a;
    border-radius: 5px;
    margin: 0.5rem 0;
  }
  .box-icon .text {
    font-size: 14px;
    font-weight: 500;
  }
  .box-icon img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    display: block;
    margin: 0 auto 0.5rem;
  }
  .box-icon:last-child,
  .box-icon:nth-child(7) {
    background-color: #234b29;
  }
  .box-icon:last-child .text,
  .box-icon:nth-child(7) .text {
    color: #ffffff;
  }
  
  /* Headings */
  h1 {
    font-size: 48px;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  h2 {
    font-size: 33px;
    font-weight: 800;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 24px;
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  h4 {
    font-size: 20px;
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  p {
    font-size: 16px;
    font-weight: 300;
    margin-top: 0.5rem;
    margin-bottom: 0.75rem;
    color: #595959;
  }
  .txt-small {
    font-size: 14px;
  }
  
  .underline {
    border-bottom: 3px solid;
    width: fit-content;
  }
  
  /* Table */
  table {
    /* border: 1px solid #9fc788; */
    border-collapse: collapse;
  }
  table td,
  table th {
    border: 2px solid #9fc788;
    padding: 0.5rem;
  }
  table thead {
    background-color: #234b29;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
  }
  table tbody {
    background-color: #d5e3cf;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
  }
  table img {
    width: 35px;
    margin: auto;
    display: block;
  }
  
  /* Text Colors */
  .txt-white {
    color: #ffffff !important;
  }
  .txt-green {
    color: #234b29;
  }
  .txt-gray {
    color: #595959;
  }
  .txt-orange {
    color: #f59d23;
  }
  
  /* Flex Grid */
  .d-flex {
    display: flex;
  }
  .align-start {
    align-items: start;
  }
  .align-center {
    align-items: center;
  }
  .align-end {
    align-items: end;
  }
  .j-center {
    justify-content: center;
  }
  
  .fd-col {
    flex-direction: column;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .j-sb {
    justify-content: space-between;
  }
  .j-sa {
    justify-content: space-around;
  }
  .j-end {
    justify-content: end;
  }
  
  /* Width */
  .w-1 {
    width: 100%;
  }
  .w-2 {
    width: 50%;
  }
  .w-3 {
    width: calc(100% / 3);
  }
  .w-4 {
    width: 25%;
  }
  .w-14 {
    width: 75%;
  }
  .w-8 {
    width: calc(100% / 8);
  }
  .w-14 {
    width: 75%;
  }
  .w-13 {
    width: calc(100% - (100% / 3));
  }
  .w-15 {
    width: calc(100% - (100% / 5));
  }
  .w-16 {
    width: calc(100% - (100% / 6));
  }
  .w-17 {
    width: calc(100% - (100% / 7));
  }
  .w-18 {
    width: calc(100% - (100% / 8));
  }
  .w-30 {
    width: 30%;
  }
  .w-40 {
    width: 40%;
  }
  .w-60 {
    width: 60%;
  }
  .w-70 {
    width: 70%;
  }
  
  /* Height */
  .h-1 {
    height: 100%;
  }
  .h-2 {
    height: calc(100% / 2);
  }
  .h-3 {
    height: calc(100% / 3);
  }
  .h-4 {
    height: calc(100% / 4);
  }
  
  .min-h-300 {
    min-height: 300px;
  }
  
  /* Padding */
  .p-1 {
    padding: 1rem;
  }
  .p-2 {
    padding: 2rem;
  }
  .p-3 {
    padding: 3rem;
  }
  .p-4 {
    padding: 4rem;
  }
  .p-5 {
    padding: 5rem;
  }
  .pt-1 {
    padding-top: 1rem;
  }
  .pt-2 {
    padding-top: 2rem;
  }
  .pt-3 {
    padding-top: 3rem;
  }
  .pt-4 {
    padding-top: 4rem;
  }
  .pt-5 {
    padding-top: 5rem;
  }
  .pl-1 {
    padding-inline-start: 1rem;
  }
  .pl-2 {
    padding-inline-start: 2rem;
  }
  .pr-1 {
    padding-inline-end: 1rem;
  }
  .pr-2 {
    padding-inline-end: 2rem;
  }
  .pl-3 {
    padding-inline-start: 3rem;
  }
  .pr-3 {
    padding-inline-end: 3rem;
  }
  .pb-1 {
    padding-bottom: 1rem;
  }
  .pb-2 {
    padding-bottom: 2rem;
  }
  .pb-3 {
    padding-bottom: 3rem;
  }
  
  /* Margin */
  .m-0 {
    margin: 0;
  }
  .mt-0 {
    margin-top: 0;
  }
  .m-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .mt-2 {
    margin-top: 2rem;
  }
  .mt-3 {
    margin-top: 3rem;
  }
  .mt-4 {
    margin-top: 4rem;
  }
  .mb-0 {
    margin-bottom: 0;
  }
  .mr-2 {
    margin-inline-end: 2rem;
  }
  
  /* ------------------------------ */
  /* Theme 3 (Modern Theme) */
  
  .theme-3 {
    font-family: "Spectral", serif;
  }
  .theme-3 .page {
    width: 674px;
    height: 871px;
    margin: 0;
    transform-origin: top left;
    position: relative;
  }
  .theme-3 .theme-3-page-1 .page-1-img {
    position: absolute;
    bottom: 0;
    min-width: calc(100% + 6rem) !important;
    height: 430px;
    transform: translate(-3rem, 2rem);
    object-fit: cover;
    object-position: center center;
  }
  .theme-3 h1,
  .theme-3 h2,
  .theme-3 h3,
  .theme-3 h4,
  .theme-3 h5 {
    color: #8c2204;
  }
  .theme-3 h1 {
    font-size: 54px;
    font-weight: 400;
  }
  .theme-3 h2 {
    font-weight: 400;
  }
  .theme-3 p {
    font-size: 16px;
    line-height: 21px;
    color: #000000;
  }
  
  .theme-3 table thead {
    background-color: transparent;
    color: #0e322b;
    font-size: 14px;
    font-weight: 400;
  }
  .theme-3 table td,
  table th {
    border: none;
  }
  .theme-3 table tbody {
    background-color: transparent;
    font-size: 16px;
    text-align: left;
  }
  
  .theme-3 table tbody tr td {
    padding-top: 1rem;
    border-bottom: 1px solid #9b9b9b7a;
    font-size: 18px;
    font-weight: 500;
  }
  .theme-3 table tbody tr td:nth-child(2) {
    color: #8c2204;
  }
  .theme-3 .page-num {
    right: auto;
    left: 0;
    bottom: 0;
    font-size: 16px;
    color: #8c2204;
    border-top: 1px solid #8c2204;
    border-right: 1px solid #8c2204;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .theme-3 .letter-page img {
    min-width: calc(100% + 6rem);
    height: 270px;
    transform: translate(-3rem, -2rem);
    object-fit: cover;
    margin-bottom: -2rem;
  }
  .theme-3 .our-story-imgs {
    width: calc(100% + 3rem);
    height: calc(100% + 4rem);
    transform: translate(0rem, -2rem);
  }
  .theme-3 .our-story-imgs img {
    object-fit: cover;
    display: block;
  }
  .theme-3 .our-mission-page {
    padding: 0;
  }
  .theme-3 .our-mission-page img {
    object-fit: cover;
    min-height: 436px;
    max-height: 436px;
  }
  
  .theme-3 .success-stories-img {
    max-width: calc(100% + 3rem);
    height: 100%;
    padding-inline-start: 0;
    width: calc(100% + 3rem);
  }
  .theme-3 .success-stories-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .theme-3 .bg-brown {
    background-color: #c38112;
  }
  .theme-3 .bg-red {
    background-color: #8c2204;
  }
  .theme-3 .bg-offwhite {
    background-color: #f2eae0;
  }
  .theme-3 ol {
    color: #8c2204;
    font-size: 22px;
    margin: 0;
    padding: 0;
    padding-inline-start: 1.5rem;
  }
  .theme-3 ol li {
    padding-inline-start: 0.5rem;
  }
  .theme-3 .text-small {
    font-size: 14px;
    line-height: 19px;
  }
  
  .theme-3 .pre-text {
    font-weight: 300;
    white-space: pre-line;
    line-height: 16px;
    font-family: "Montserrat";
    width: 100%;
    color: rgb(89, 89, 89);
  }
  
  .theme-3 .priorities-page img {
    min-width: calc(100% + 6rem);
    height: calc(100% + 1rem);
    transform: translate(-3rem, 0rem);
    object-fit: cover;
  }
  .theme-3 .learning-page {
    /* background-image: url("/images/learning-img.png"); */
    background-position: left;
  }
  .theme-3 .learning-page .page-num {
    border-color: #f2eae0;
    color: #f2eae0;
  }
  .theme-3 .list-surveys .box .circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #8c2204;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    color: #8c2204;
  }
  
  .theme-3 .list-ways .box i {
    color: #8c2204;
    font-size: 36px;
    padding-inline-end: 1rem;
  }
  .theme-3 .ways-icon {
    min-width: 25px;
    max-width: 25px;
    margin-right: 5px;
  }
  
  .theme-3 .donor-table thead {
    border: 1px solid;
  }
  
  .theme-3 .donor-table thead th {
    border: 1px solid;
  }
  
  .theme-3 .donor-table th,
  .theme-3 .donor-table td {
    font-weight: 400;
    font-size: 13px;
  }
  .theme-3 .donor-table .checked {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: auto;
  }
  
  .theme-3 .donor-table tbody tr td {
    padding: 0 1rem;
    height: 60px;
  
    border: 1px solid;
  }
  .theme-3 .donor-table thead tr th:first-child {
    width: 500px;
    text-align: left;
    padding-right: 0;
  }
  
  .theme-3 .breakdown-table th,
  .theme-3 .breakdown-table td {
    font-family: "Times New Roman", Times, serif;
    font-size: 13px;
  }
  .theme-3 .breakdown-table .checked {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #c38112;
    margin: auto;
  }
  .theme-3 .breakdown-table tbody tr td {
    height: 60px;
  }
  .theme-3 .breakdown-table tbody tr td:first-child {
    border: 1px solid;
  }
  .theme-3 .breakdown-table tbody tr td:last-child {
    border: 1px solid;
  }
  .theme-3 .breakdown-table tbody tr td {
    padding: 0 1rem;
  }
  .theme-3 .breakdown-table thead tr th:first-child {
    width: 500px;
    text-align: left;
    padding-right: 0;
  }
  
  .success-stories-img {
    position: relative;
    top: -2rem;
    object-fit: cover;
    object-position: center;
    padding-inline-start: 5rem;
  }
  </style>
  
  .mini-preview {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }
  
  .mini-preview:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  
  /* Ensure mini pages maintain aspect ratio */
  .theme-3 .mini-page {
    aspect-ratio: 674/871;
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
  }
  
  /* Adjust spacing between mini pages */
  .theme-3 .mini-page + .mini-page {
    margin-top: 1rem;
  }
  
  /* Ensure content scales properly */
  .theme-3 .mini-page * {
    transform-origin: top left;
  }
  
  